import React from 'react'
// import _ from 'lodash'
// import { TyanDateTimeField } from '@sencha/ext-modern'
import { DateTimePickerComponent, Inject, MaskedDateTime } from '@syncfusion/ej2-react-calendars'

import { nullDate } from '../../../utility'
import { getMixedProps } from './blockPublic'
// import LabelContext from './WrappedLabel'
import { useEventHandler } from 'tyan/public/hooks'

// const handlerDateTimeChange = (name, initValue, onChange) => (field, inputValue) => {
// 	const newValue = inputValue ?
// 		Date.UTC(
// 			inputValue.getFullYear(),
// 			inputValue.getMonth(),
// 			inputValue.getDate(),
// 			inputValue.getHours(),
// 			inputValue.getMinutes()
// 		).valueOf() :
// 		nullDate
// 	onChange({ name, newValue: newValue, type: 'datetime' })
// }

const DateTime = ({ config: { field, onChange, initValues,/*  changedValues,  */defaultStyle, that } }) => {
	const { value: currentValue, name } = field
	const value = Tyan.sysMode === 'sample' && typeof currentValue === 'string'
		? Tyan.Date.getSecond(currentValue)
		: currentValue && currentValue !== nullDate && Tyan.Date.getSecondLocal(currentValue) || null

	// const d = currentValue && currentValue !== nullDate && new Date(currentValue) || null
	// const value = d && new Date(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate(), d.getUTCHours(), d.getUTCMinutes())
	const handleChange = useEventHandler(({ value: inputValue }) => {
		const newValue = inputValue ? Tyan.Date.getSecondUtcValue(inputValue) : nullDate
		onChange({ name, newValue: newValue, type: 'datetime' })

	})

	let { props: { disabled, minDate, min, maxDate, max, unit, clearable, ...props } } = getMixedProps('_datetime', [defaultStyle, field])
	min = min || minDate
	max = max || maxDate
	min && (props.min = min)
	max && (props.max = max)
	// console.log('props:', props)

	return <DateTimePickerComponent {...props} /* {...labelContext} */ change={handleChange}
		// format='y/MM/dd HH:mm' timeFormat='HH:mm'
		{...unit === 'S' ? { format: 'yyyy/MM/dd HH:mm:ss', timeFormat: 'HH:mm:ss' } : { format: 'yyyy/MM/dd HH:mm', timeFormat: 'HH:mm' }}
		enableMask maskPlaceholder={{ year: 'yyyy', month: 'mm', day: 'dd', hour: 'hh', minute: 'mm', second: 'ss' }}
		value={value}
		enabled={!disabled} showClearButton={clearable}
	/* openOnFocus */
	>
		<Inject services={[MaskedDateTime]} />
	</DateTimePickerComponent>
	// const d = field.value && field.value !== nullDate && new Date(field.value) || null
	// const value = d && new Date(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate(), d.getUTCHours(), d.getUTCMinutes())
	// return <TyanDateTimeField {...getMixedProps('_datetime', [defaultStyle, field]).props} value={value}
	// 	destroyPickerOnHide
	// 	onChange={handlerDateTimeChange(field.name, initValues[field.name], onChange)}
	// 	onErrorChange={(field, error) => that.setState(state => ({ formErrorCount: (state.formErrorCount || 0) + (error ? 1 : -1) }))}
	// 	floatedPicker={{ captionFormat: 'Y F', header: { hidden: false } }}
	// />
}

const renderDateTime = config => {
	const { key } = config.field || {}
	return <DateTime key={key} config={config} />
}


export default renderDateTime